module.exports = __webpack_public_path__ + "static/media/check-box_off.857cc1cb.svg";